import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // After Turbo Stream replaces the dropdown, restore the previous selection
    const url = new URL(window.location.href)
    const currentBridge = url.searchParams.get("bridge_name")
    if (currentBridge && this.element.querySelector(`option[value="${CSS.escape(currentBridge)}"]`)) {
      this.element.value = currentBridge
    }
  }

  switch() {
    const bridgeName = this.element.value
    const url = new URL(window.location.href)

    if (bridgeName) {
      url.searchParams.set("bridge_name", bridgeName)
    } else {
      url.searchParams.delete("bridge_name")
    }

    window.location.href = url.toString()
  }
}
